(() => {
  const SECTION_SELECTOR = '.cuft-section-reviews-carousel';
  const sectionState = new Map();

  function initSection(section) {
    const track = section.querySelector('.cuft-section-reviews-carousel__track');
    const prevBtn = section.querySelector('.cuft-section-reviews-carousel__nav-btn--prev');
    const nextBtn = section.querySelector('.cuft-section-reviews-carousel__nav-btn--next');
    if (!track || !prevBtn || !nextBtn) return;

    const controller = new AbortController();
    const signal = controller.signal;

    /* ── Autoplay ── */
    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplaySpeed = (parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
    let autoplayTimer = null;
    let isPaused = false;

    function getScrollStep() {
      const card = track.querySelector('.cuft-section-reviews-carousel__card');
      if (!card) return 300;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.gap) || 0;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function autoAdvance() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || isPaused) return;
      stopAutoplay();
      autoplayTimer = setInterval(autoAdvance, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      stopAutoplay();
      startAutoplay();
    }, { signal });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      stopAutoplay();
      startAutoplay();
    }, { signal });

    /* Pause autoplay on hover / focus-within */
    section.addEventListener('mouseenter', () => {
      isPaused = true;
      stopAutoplay();
    }, { signal });

    section.addEventListener('mouseleave', () => {
      isPaused = false;
      startAutoplay();
    }, { signal });

    section.addEventListener('focusin', () => {
      isPaused = true;
      stopAutoplay();
    }, { signal });

    section.addEventListener('focusout', (e) => {
      if (!section.contains(e.relatedTarget)) {
        isPaused = false;
        startAutoplay();
      }
    }, { signal });

    let scrollRaf = null;
    track.addEventListener('scroll', () => {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = null;
        updateArrows();
      });
    }, { passive: true, signal });

    const reviews = section.querySelectorAll('.cuft-section-reviews-carousel__review');

    function syncClamp(text, btn) {
      if (text.classList.contains('is-expanded')) return;
      text.classList.add('is-clamped');
      btn.hidden = text.scrollHeight <= text.clientHeight + 1;
    }

    const clamps = [];

    reviews.forEach((review) => {
      const text = review.querySelector('.cuft-section-reviews-carousel__review-text');
      const btn = review.querySelector('.cuft-section-reviews-carousel__read-more');
      if (!text || !btn) return;

      clamps.push(() => syncClamp(text, btn));
      syncClamp(text, btn);

      btn.addEventListener('click', () => {
        const expanded = !text.classList.contains('is-expanded');
        text.classList.toggle('is-expanded', expanded);
        text.classList.toggle('is-clamped', !expanded);
        btn.setAttribute('aria-expanded', String(expanded));
        btn.textContent = expanded ? 'Read Less' : 'Read More';
      }, { signal });
    });

    let resizeRaf = null;
    window.addEventListener('resize', () => {
      if (resizeRaf) return;
      resizeRaf = requestAnimationFrame(() => {
        resizeRaf = null;
        clamps.forEach((fn) => fn());
      });
    }, { passive: true, signal });

    updateArrows();
    startAutoplay();

    sectionState.set(section, {
      controller,
      cleanup: () => {
        stopAutoplay();
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
      }
    });
  }

  function destroySection(section) {
    const state = sectionState.get(section);
    if (!state) return;
    state.controller.abort();
    state.cleanup();
    sectionState.delete(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();